<template>
    <div>
        <el-drawer title="企业设置" :visible.sync="isShow" size="900px" @close="$emit('close')">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
                <el-form-item label="公司名称" prop="name">
                    <el-input v-model="searchForm.name" placeholder="公司名称" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom: 10px">
                <el-button icon="el-icon-plus" type="primary" size="small" @click="handleAdd">新增</el-button>
            </div>
            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column prop="name" label="公司名称" width="220"></el-table-column>
                <el-table-column prop="contact" label="联系人" width="120"></el-table-column>
                <el-table-column prop="phone" label="电话号码" width="120"></el-table-column>
                <el-table-column prop="totalPayment" label="累计总金额" width="120"></el-table-column>
                <el-table-column prop="noSettlePayment" label="待结算金额" width="120"></el-table-column>
                <el-table-column prop="settlePayment" label="已结算金额" width="120"></el-table-column>
                <el-table-column prop="remark" label="备注" width="120"></el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="150">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
                        <el-button size="mini" type="text" style="color:red" @click="handleDelDict(row)">删除</el-button>
                        <el-dropdown trigger="click">
                            <span style="padding: 0 10px;cursor: pointer;margin-left: 10px;">
                                <i class="el-icon-more"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <el-button size="mini" type="text" @click="handleBindUser(row)">绑定用户</el-button>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <el-button size="mini" type="text" style="color: red; width: 100%" @click="handleAccount(row)">结算</el-button>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <el-button size="mini" type="text" @click="handleOrderDetail(row)">账单明细</el-button>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </el-drawer>

        <el-dialog :visible.sync="isAdd" :title="!modelForm.id ? '添加' : '编辑'" width="520px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="warn-tips">
                <i class="el-icon-info"></i>
                <div>
                    <span>1.添加企业基本信息，确认企业订单主体</span>
                </div>
            </div>
            <el-form ref="modelForm" :model="modelForm" label-width="110px" style="margin: 0 20px" size="small">
                <el-form-item label="企业名称" prop="name" :rules="[{required: true, message: '请输入企业名称', trigger: 'blur'}]">
                    <el-input type="text" v-model="modelForm.name" placeholder="请输入企业名称" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="contact" :rules="[{required: true, message: '请输入联系人名称', trigger: 'blur'}]">
                    <el-input type="text" v-model="modelForm.contact" placeholder="请输入" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone" :rules="[{required: true, message: '请输入手机号', trigger: 'blur'},{pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,message: '请输入正确的手机号', trigger: 'blur'}]">
                    <el-input type="text" v-model="modelForm.phone" placeholder="请输入手机号码" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="text" v-model="modelForm.remark" placeholder="请输入" style="width: 240px"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isAdd = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
        <BindUser :isBindUser="isBindUser" @close="isBindUser = false" :enterpriseId="enterpriseId" :hotelId="hotelId"></BindUser>
        <OrderDetail :isOrderDetail.sync="isOrderDetail" :enterpriseId="enterpriseId" :hotelId="hotelId"></OrderDetail>
        <AccountList :isShowDetail.sync="isShowAccount" :enterpriseId="enterpriseId" :hotelId="hotelId"></AccountList>
    </div>
</template>


<script>
import { deepClone } from '@/utils/util'
import BindUser from './bindUser/index'
import OrderDetail from './orderDetail/index'
import AccountList from './accountList/index'
export default {
    props: {
        isRoomType: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
    },
    components: {
        BindUser,
        OrderDetail,
        AccountList
    },
    computed: {
        headers() {
            return {
                Authorization: localStorage.getItem("Token"),
            };
        },
    },
    data() {
        return {
            isShow: false,
            isBindUser: false,
            isOrderDetail: false,
            isShowAccount: false,
            searchForm: {
                name: "",
                hotelId: this.hotelId,
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            tableData: [],
            total: 0,
            selectTime: [],
            isAdd: false,
            modelForm: {
                name: '',
                contact: '',
                phone: '',
                remark: ''
            },
            imgUrl: "",
            submitLoading: false,
            enterpriseId: ''
        };
    },
    watch: {
        isRoomType(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    name: "",
                    hotelId: this.hotelId,
                    pageNumber: 1,
                    pageSize: 10,
                };
                this.getTableData();
            }
        },
    },
    methods: {
        handleBindUser(row) {
            this.enterpriseId = row.id;
            this.isBindUser = true;
        },
        handleDelDict(row) {
            this.$confirm(`您确认要解除${row.name}?`, "确认解除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.deleteRequest(`/enterprise/deleteEnterprise?id=${row.id}`)
                    .then(res => {
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success("解除成功");
                            this.getTableData();
                        }
                    })
            })
        },
        handleOrderDetail(row) {
            this.enterpriseId = row.id;
            this.isOrderDetail = true;
        },
        handleAccount(row) {
            this.enterpriseId = row.id
            this.isShowAccount = true;
        },
        handleSubmit(fromName) {
            this.$refs[fromName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.modelForm.hotelId = this.hotelId
                    if (!this.modelForm.id) {
                        this.postRequest("/enterprise/addEnterprise", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getTableData();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    } else {
                        this.putRequest("/enterprise/editEnterprise", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getTableData();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    }
                }
            });
        },
        handleAdd() {
            this.modelForm = {
                hotelId: this.hotelId,
            };
            this.isAdd = true;
        },
        handleEdit(row) {
            this.modelForm = deepClone(row);
            this.isAdd = true
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                hotelId: this.hotelId,
                name: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/enterprise/getPage", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },

    },
};
</script>

<style lang="less">
.warn-tips {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: #eeeeee;
    margin-bottom: 10px;
    font-size: 12px;
}

.warn-tips i {
    font-size: 20px;
    color: #409eff;
    margin-right: 5px;
}
</style>